<template>
    <div id="received-files-header" class="bg-white p-3">
        <div class="d-flex align-items-center h-100">
            <transition name="slide">
                <font-awesome-icon 
                    v-if="file.selected || file.selectedFolder" 
                    :icon="['fad', 'chevron-circle-left']" 
                    fixed-width 
                    class="fa-2x mr-3 text-primary back-icon" 
                    @click="$router.go(-1)">
                </font-awesome-icon>
            </transition>
            <h3>Received Files
                <span v-if="file.selectedFolder"> &gt; {{file.selectedFolder}}</span>
                <span v-if="file.selected"> &gt; {{file.selected.Name}}</span>
            </h3>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState(['file', ['selectedFolder', 'selected']])
    }
}
</script>
<style scoped>
#received-files-header {
    min-height: 75px;
    height: 75px;
}

#received-files-header h3 {
    margin: 0;
}

.back-icon {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-header.vue